import React, { useContext } from "react";
import styled from "styled-components";
import { Form, Formik } from "formik";
import { Button, ButtonToolbar, Col, Row, Input } from "components/bootstrap";
import InputProfileHelpPanel from "./InputProfileHelpPanel";
import { StyledTitle } from "../StyledWizardComponents";
import { ForwarderWizardContext } from "../ForwarderWizardProvider";
import { InputProfilesActions } from "../../stores/InputProfilesStore";
const StyledHelpComponent = styled.div`
  margin-top: 30px;
`;
const InputProfileForm = ({ onCancel, onInputProfileCreated }) => {
  const { selectedForwarder } = useContext(ForwarderWizardContext);
  if (!selectedForwarder) {
    return /* @__PURE__ */ React.createElement("div", null, "Please select a Forwarder before continuing to this step.");
  }
  const submitInputProfile = (values, { setSubmitting }) => {
    InputProfilesActions.create(values).then((inputProfile) => {
      setSubmitting(false);
      onInputProfileCreated(inputProfile);
    });
  };
  return /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 6 }, /* @__PURE__ */ React.createElement(StyledTitle, null, "Add Input Profile to ", /* @__PURE__ */ React.createElement("em", null, selectedForwarder.title)), /* @__PURE__ */ React.createElement(Formik, { initialValues: { title: "", description: "" }, onSubmit: submitInputProfile }, ({ values, handleChange, isSubmitting }) => /* @__PURE__ */ React.createElement(Form, null, /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "title",
      name: "title",
      label: "Title",
      type: "text",
      value: values.title,
      onChange: handleChange,
      help: "Meaningful name used to identify this Input Profile.",
      required: true
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "description",
      name: "description",
      label: /* @__PURE__ */ React.createElement("span", null, "Description ", /* @__PURE__ */ React.createElement("small", null, "(Optional)")),
      type: "text",
      value: values.description,
      onChange: handleChange,
      help: "Longer description for this Input Profile."
    }
  ), /* @__PURE__ */ React.createElement(ButtonToolbar, null, /* @__PURE__ */ React.createElement(Button, { onClick: onCancel }, "Cancel"), /* @__PURE__ */ React.createElement(Button, { type: "submit", bsStyle: "primary", disabled: isSubmitting }, isSubmitting ? "Saving your changes..." : "Add Inputs"))))), /* @__PURE__ */ React.createElement(Col, { md: 4, mdOffset: 1 }, /* @__PURE__ */ React.createElement(StyledHelpComponent, null, /* @__PURE__ */ React.createElement(InputProfileHelpPanel, null))));
};
export default InputProfileForm;
